import { Injectable } from '@angular/core';
import { BaseService, E8HttpClient, C8HttpClientOptions } from '../../../../core';
import { DynamicWindowSingleGetMetaInfoRequest } from "./model/dynamicWindowSingleGetMetaInfoRequest";
import { DynamicWindowSingleGetMetaInfoResponse } from "./model/dynamicWindowSingleGetMetaInfoResponse";
@Injectable()
export class DynamicWindowSingleService extends BaseService {
    private getMetaInfo_URL = 'metabase/dynamicWindowSingle/getMetaInfo';
    constructor(private client: E8HttpClient) {
        super();
    }
    getMetaInfo(request: DynamicWindowSingleGetMetaInfoRequest, options?: C8HttpClientOptions): Promise<DynamicWindowSingleGetMetaInfoResponse> {
        return this.client.post(this.fUrl(this.getMetaInfo_URL), request, options);
    }
}
